module.exports = __webpack_public_path__ + "media/customizations/regencyatwaterset/logo-41024dccf10ebaab0d65a834e74db2d2.png";